// extracted by mini-css-extract-plugin
module.exports = {"wrap_poll":"oOjck","poll_withoutLogin":"rHGuo","inner":"xUILg","login_options":"tKOOs","loginOptionWrap":"OrWkr","google":"gFN4N","submit":"kYIGH","wrap_page":"TIrkt"};